<template>
    <modal class="w-full h-full" :width="modalWidth" :partners="true" @close="$emit('close')">
        <div class="relative" :class="modalClasses">
            <button class="absolute pin-t pin-r outline-none m-5 z-40" @click="$emit('close')">
                <img class="" src="@/assets/SVG/cross-partners.svg"/>
            </button>
            <div class="px-4 lg:px-10 pt-16">
                <div class="flex text-center justify-center" :class="textClasses">
                    <p class="text-main-text font-semibold md:text-xl " v-text="text"></p>
                </div>
            </div>
            <div class="p-10 flex flex-row justify-between" slot="footer">
                <button @click="$emit('white_button')" class="inline-block text-sm justify-center hover-up font-bold bg-white border border-main-text text-main-text rounded-full px-2 md:px-6 py-2 md:py-3 outline-none confirm-button">
                    <span v-text="button_text_firs"></span>
                </button>
                <button @click="$emit('yellow_button')" class="outline-none text-sm ml-4 rounded-full hover-up flex flex-row items-center text-main-text justify-center bg-brand-yellow px-3 md:px-8 confirm-button">
                    <span class="mx-3 font-semibold" v-text="button_text_second"></span>
                </button>
            </div>
        </div>
    </modal>

</template>
<script>
import ModalMixin from '../../../mixins/modals';
import Modal from '@/views/modals/base-modal';
import isMobile from '../../../mixins/isMobile';


export default {
  name: 'DeleteModal',
  components: { Modal },
  props: ['text', 'button_text_firs', 'button_text_second', 'modalClasses', 'textClasses'],

  mixins: [ModalMixin, isMobile],
  computed: {
    modalWidth() {
      if (this.isMobile === 'mobile') {
        return 320;
      }
      return 420;
    },
  },
};

</script>


<style scoped>
.confirm-button {
    width: 200px;
}
</style>

